var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offside-div"},[_c('h3',{staticClass:"manutencao text-center"},[_vm._v(" Mercado em manutenção")])])
}]

export { render, staticRenderFns }